import styled from "styled-components";

export const Label = styled.label`
  font-size: 14px;
  font-weight: 200;
  padding: 0;
`;

export const Wrapper = styled.div`
  margin-top: 20px;
  border: 1px solid #eeeeee;
`;

export const IndentedWrapper = styled.div`
  margin-left: 10px;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.h3`
  margin: 20px 24px 20px 24px;
  padding: 0 0 20px;
  font-size: 20px;
  font-weight: 500;
  border-bottom: solid 1px #eeeeee;
`;

export const SubHeader = styled.div`
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 500;
`;

export const ContentWrapper = styled.div`
  margin: 0 24px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  justify-content: space-between;
  max-width: 350px;
  margin: 0.5em 0;
`;
